import { render, staticRenderFns } from "./PrintTopUpButton.vue?vue&type=template&id=23f979fa&"
import script from "./PrintTopUpButton.vue?vue&type=script&lang=ts&"
export * from "./PrintTopUpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports